import _ from 'lodash';
import angular from 'angular';
import Logger from '../../../shared/logger';
import { CANDIDATE_FEEDBACK_STATUSES } from '../constants/feedback';
import { EMPLOYER_WORKFLOW_STATUS } from '../../employer/constants/employer-workflow';

const RecruiterFeedbackService = (Restangular, RecruiterCandidateService, PositionService) => {
    const getFeedbackCandidates = async ({
        recruiterId,
        positionId,
        isListView,
        pageOptions,
        filter,
    }) => {
        const { result } = await Restangular
            .one('recruiter', recruiterId)
            .one('position', positionId)
            .one('workflowStep', EMPLOYER_WORKFLOW_STATUS.FEEDBACK)
            .all('candidates')
            .post({
                isListView,
                pageOptions,
                filter,
            });

        return result;
    };

    const requestFeedback = async (positionId, candidate) => {
        try {
            return await PositionService.requestFeedback(positionId, { candidatesIds: [candidate.workflow.candidateId] });
        } catch (error) {
            Logger.error(error);
        }
    };

    const removeRequestFeedback = async (positionId, candidate) => {
        try {
            return await PositionService.removeRequestFeedback(positionId, { candidatesIds: [candidate.workflow.candidateId] });
        } catch (error) {
            Logger.error(error);
        }
    };

    const sendFeedbackToEmployer = async (positionId, candidates) => {
        try {
            return await PositionService.postPositionFeedback(positionId, candidates);
        } catch (error) {
            Logger.error(error);
        }
    };

    const multiRequestFeedback = async (positionId, candidates) => {
        const candidatesIds = (candidates || []).map(({ workflow }) => workflow.candidateId);

        try {
            return await PositionService.requestFeedback(positionId, { candidatesIds });
        } catch (error) {
            Logger.error(error);
        }
    };

    const multiRemoveRequestFeedback = async (positionId, candidates) => {
        const candidatesIds = (candidates || []).map(({ workflow }) => workflow.candidateId);

        try {
            return await PositionService.removeRequestFeedback(positionId, { candidatesIds });
        } catch (error) {
            Logger.error(error);
        }
    };

    const getFeedbackStatisticsForCandidates = (candidates) => {
        return (candidates || []).reduce((result, candidate) => {
            const feedbackStatus = _.get(candidate, 'workflow.feedback.status', CANDIDATE_FEEDBACK_STATUSES.NONE);

            switch (feedbackStatus) {
                case CANDIDATE_FEEDBACK_STATUSES.NONE:
                    return {
                        ...result,
                        none: [
                            ...result.none,
                            candidate,
                        ],
                    };
                case CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND:
                    return {
                        ...result,
                        readyForSend: [
                            ...result.readyForSend,
                            candidate,
                        ],
                    };
                case CANDIDATE_FEEDBACK_STATUSES.ACCEPTED:
                    return {
                        ...result,
                        accepted: [
                            ...result.accepted,
                            candidate,
                        ],
                    };
                case CANDIDATE_FEEDBACK_STATUSES.PENDING:
                    return {
                        ...result,
                        pending: [
                            ...result.pending,
                            candidate,
                        ],
                    };
                default:
                    return result;
            }
        }, {
            none: [],
            readyForSend: [],
            pending: [],
            accepted: [],
            allCount: candidates.length,
        });
    };

    return {
        requestFeedback,
        removeRequestFeedback,
        sendFeedbackToEmployer,
        multiRequestFeedback,
        multiRemoveRequestFeedback,
        getFeedbackStatisticsForCandidates,
        getFeedbackCandidates,
    };
};

angular.module('TALENYA-FE')
    .factory('RecruiterFeedbackService', RecruiterFeedbackService);
